export default __webpack_public_path__ + "static/media/scrollImage2.d0693959.jpg";